import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export enum SnackbarVariants {
  Success = 0,
  Info = 1,
}

export interface SnackbarParameters {
  header: string;
  message: string;
  variant: SnackbarVariants;
}

@Component({
    selector: 'snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarParameters) {}

  getVariantClass() {
    switch (this.data.variant) {
      case SnackbarVariants.Success:
        return 'success';
      case SnackbarVariants.Info:
        return 'info';
      default:
        return '';
    }
  }

  getVariantIcon() {
    switch (this.data.variant) {
      case SnackbarVariants.Success:
        return 'assets/icons/check-icon-white.png';
      case SnackbarVariants.Info:
        return 'assets/icons/info-icon-white.png';
      default:
        return 'assets/icons/info-icon-white.png';
    }
  }
}
